<template>
  <section class="main">
    <v-page-header :title="$t('tours.title')" />

    <div class="grid-container">
      <div class="grid-x">
        <div class="cell medium-9 medium-offset-1 large-11 large-offset-0">
          <v-action-buttons :items="getActionButtons" />
          <v-form-message
            type="default"
            :message="objectRemoveConfirm"
            :autoCloseTimeout="0"
            :showActionButtons="true"
            @onClickAction="onClickDialogAction"
          />
          <v-form-message
            type="error"
            id="form-error"
            :message="objectError"
            @onClickAction="onClickDialogAction"
          />

          <v-form-message
            type="error"
            id="form-error"
            :message="objectError"
            @onClickAction="onClickDialogAction"
          />

          <div class="box">
            <form
              action
              method="POST"
              class="filter filter--search"
              novalidation
              @submit="onChangeResultsTableFilter"
            >
              <div class="filter__grid">
                <div class="filter__grid__item">
                  <div class="form-group">
                    <label for="form-field-tournumber">{{ $t('tours.tournumber') }}</label>
                    <input
                      type="text"
                      id="form-field-tournumber"
                      class="form-control form-control--small"
                      :placeholder="$t('tours.tournumber')"
                      v-model="filter.tour_number"
                    />
                  </div>
                </div>
                <div class="filter__grid__item filter__grid__item--normal">
                  <div class="form-group">
                    <label>{{ $t('search.from') }}</label>
                    <v-datepicker
                      class="form-control form-control--small form-control--date"
                      :placeholder="$t('search.from')"
                      :format="$t('search.from') + ' ' + $helpers.dateFormat"
                      :clearButton="true"
                      :monday-first="true"
                      :disabled-dates="$helpers.disabledDates"
                      :language="de"
                      v-model="filter.startdate"
                    />
                  </div>
                </div>
                <div class="filter__grid__item filter__grid__item--normal">
                  <div class="form-group">
                    <label>{{ $t('search.till') }}</label>
                    <v-datepicker
                      class="form-control form-control--small form-control--date"
                      :placeholder="$t('search.till')"
                      :format="$t('search.till') + ' ' + $helpers.dateFormat"
                      :clearButton="true"
                      :monday-first="true"
                      :disabled-dates="{ days: [6, 0], to : new Date(filter.startdate) }"
                      :language="de"
                      v-model="filter.enddate"
                    />
                  </div>
                </div>
                <div class="filter__grid__item">
                  <div class="form-group">
                    <label for="form-field-kolonne">Kolonne</label>
                    <v-select-kolonne
                      id="form-field-kolonne"
                      name="kolonne"
                      :placeholder="$t('select_all')"
                      v-model="filter.kolonne"
                    />
                  </div>
                </div>
                <div class="filter__grid__item filter__grid__item--normal">
                  <button
                    role="button"
                    type="submit"
                    class="button u-extra-small-margin--top"
                    :title="$t('search')"
                  >{{ $t('search') }}</button>
                </div>
              </div>
            </form>

            <v-table
              :isLoading="resultsTableLoading"
              :columns="resultsTableColumns"
              :items="resultsTableItems"
              :showHeaderRow="true"
              :showShowAll="false"
              :useDetailRow="false"
            >
              <template slot="tour_number" slot-scope="{ row }">
                <span class="table-label">{{ row.tour_number }}</span>
              </template>

              <template slot="kolonne" slot-scope="{ row }">
                <span>{{ row.kolonne }}</span>
              </template>

              <template slot="startdate" slot-scope="{ row }">
                <span>{{ row.startdate | moment('DD.MM.YYYY') }}</span>
              </template>

              <template slot="enddate" slot-scope="{ row }">
                <span>{{ row.enddate | moment('DD.MM.YYYY') }}</span>
              </template>

              <template slot="update" slot-scope="{ row }">
                <router-link
                  :to="{ name : 'update-tour', params: {tour: row.id} }"
                  class="button button--action button--action--edit button--small"
                  :title="$t('update')"
                >{{ $t('update') }}</router-link>
              </template>

              <template slot="pdf" slot-scope="{ row }">
                <a
                  class="button button--action button--action--pdf button--small"
                  :title="$t('generatepdf')"
                  @click.prevent="generateTourPdf(row.id, row.tour_number)"
                >{{ $t('generatepdf') }}</a>
              </template>

              <template slot="duplicate" slot-scope="{ row }">
                <router-link
                  :to="{ name : 'duplicate-tour', params: {tour: row.id} }"
                  class="button button--action button--action--duplicate button--small"
                  :title="$t('duplicate')"
                >{{ $t('duplicate') }}</router-link>
              </template>

              <template slot="delete" slot-scope="{ row }">
                <a
                  @click.prevent="onOpenDeleteDialog(row.id, row.tour_number)"
                  class="button button--action button--action--delete button--small"
                >{{ $t('delete') }}</a>
              </template>
            </v-table>

            <v-pagination
              :currentPage="resultsTableCurrentPage"
              :itemsPerPage="resultsTableItemsPerPage"
              :items="resultsTableItemsCount"
              @pageClicked="onChangeResultsTablePage"
            />
          </div>

          <v-pdf-dialog
            :isVisible="pdfDialogIsVisible"
            :tourId="pdfTourId"
            :tourNumber="pdfTourNumber"
            v-model="pdfDialogIsVisible"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import PageHeader from "./../partials/PageHeader";
import SelectKolonne from "./../partials/Forms/SelectKolonne";
import ActionButtons from "./../partials/Foundation/ActionButtons";
import Datepicker from "vuejs-datepicker";
import { de } from "vuejs-datepicker/dist/locale";
import Table from "./../partials/Foundation/Table";
import Pagination from "./../partials/Foundation/Pagination";
import FormMessage from "../partials/Forms/FormMessage";
import TourPdfDialog from "../partials/TourPdfDialog";

export default {
  name: "Tours",
  data: function() {
    return {
      de: de,
      deleteTourId: null,
      objectError: null,
      objectRemoveConfirm: null,
      resultsTableLoading: true,
      resultsTableColumns: [
        { key: "tour_number", label: "Tournummer" },
        { key: "kolonne", label: "Kolonne" },
        { key: "startdate", label: "Von" },
        { key: "enddate", label: "Bis" },
        {
          key: "update",
          width: "46px"
        },
        {
          key: "pdf",
          width: "46px"
        },
        {
          key: "duplicate",
          width: "46px"
        },
        {
          key: "delete",
          width: "46px"
        }
      ],
      resultsTableCurrentPage: this.$route.query.page || 1,
      resultsTableItemsPerPage: 6,
      resultsTableItems: [],
      resultsTableItemsCount: 0,
      filter: {
        kolonne: this.$route.query.kolonne || "",
        enddate: this.$route.query.enddate || "",
        startdate: this.$route.query.startdate || "",
        tour_number: this.$route.query.tour_number || ""
      },
      pdfDialogIsVisible: false,
      pdfTourId: 0,
      pdfTourNumber: ""
    };
  },
  components: {
    vPageHeader: PageHeader,
    vActionButtons: ActionButtons,
    vTable: Table,
    vPagination: Pagination,
    vDatepicker: Datepicker,
    vSelectKolonne: SelectKolonne,
    vFormMessage: FormMessage,
    vPdfDialog: TourPdfDialog
  },
  computed: {
    getActionButtons: function() {
      let buttons = [];

      buttons.push({
        action: "create-new",
        router: { name: "create-tour" }
      });

      return buttons;
    }
  },
  created: function() {
    this.onUpdateResultsTableItems(true);
  },
  methods: {
    onClickDialogAction: function(id, action) {
      this.objectError = null;
      this.objectRemoveConfirm = null;
      switch (action) {
        case "yes":
          this.onDeleteObject();
          break;
      }
    },

    onOpenDeleteDialog: function(tourId, tourNumber) {
      this.deleteTourId = tourId;
      this.objectRemoveConfirm =
        this.$t("tours.message.delete") +
        "<p class='text-center'><strong>" +
        tourNumber +
        "</strong></p>";
    },

    onDeleteObject: function() {
      this.objectError = null;
      this.objectRemoveConfirm = null;

      let promise = this.$api
        .clearParams()
        .post("tours/" + this.deleteTourId + "/delete");

      promise
        .then(
          (response => {
            this.deleteTourId = null;
            this.onUpdateResultsTableItems();
          }).bind(this)
        )
        .catch(
          (error => {
            this.objectError = this.$t(error.response.data.message);
          }).bind(this)
        );
    },

    onUpdateFilterParameters: function() {
      let query = {
        page: this.resultsTableCurrentPage
      };

      for (let key in this.resultsTableFilter) {
        if (this.resultsTableFilter[key]) {
          if (key === "startdate" || key === "enddate") {
            query[key] = this.formatDate(this.resultsTableFilter[key]);
          } else {
            query[key] = this.resultsTableFilter[key];
          }
        }
      }

      this.$router.push({ query: query });
    },

    onChangeResultsTablePage: function(page) {
      this.resultsTableCurrentPage = page;
      this.onUpdateResultsTableItems();
    },

    onChangeResultsTableFilter: function(event) {
      event.preventDefault();
      this.resultsTableLoading = true;
      this.resultsTableCurrentPage = 1;
      this.onUpdateResultsTableItems();
    },

    formatDate: function(date) {
      if (date === "" || date === null || date === undefined) {
        return "";
      }

      return this.$moment(date).format("YYYY-MM-DD");
    },

    onUpdateResultsTableItems: function(firstUpdate) {
      if (!firstUpdate) {
        this.onUpdateFilterParameters();
      }
      let promise = this.$api
        .clearParams()
        .addParam("tour_number", this.filter.tour_number)
        .addParam("startdate", this.formatDate(this.filter.startdate))
        .addParam("enddate", this.formatDate(this.filter.enddate))
        .addParam("kolonne", this.filter.kolonne)
        .setPageParams(
          this.resultsTableCurrentPage,
          this.resultsTableItemsPerPage
        )
        .setSortParams("createdon", "desc")
        .get("tours");

      promise
        .then(
          (response => {
            this.resultsTableItems = response.data.data;
            this.resultsTableItemsCount = response.data.meta.pagination.total;

            this.resultsTableLoading = false;
          }).bind(this)
        )
        .catch(
          (error => {
            this.resultsTableItems = [];
            this.resultsTableItemsCount = 0;

            this.resultsTableLoading = false;
          }).bind(this)
        );

      this.resultsTableLoading = true;
    },

    generateTourPdf: function(tourId, tourNumber) {
      this.pdfDialogIsVisible = true;
      this.pdfTourId = tourId;
      this.pdfTourNumber = tourNumber;
    }
  }
};
</script>